import React from "react";
import "./GaugeMeter.css";
import { motion } from "framer-motion";

const GaugeMeter = ({ status: products }) => {

  console.log(products, 'selected');

  // Filter selected products (true values)
  const selectedProducts = products.filter((product) => product);
  const selectedPercentage = (selectedProducts.length / products.length) * 100;
  console.log(selectedPercentage,'perectn')
  // Convert value (0-100) to rotation (-90 to 90 degrees)
  // const value = 45;
  const rotation = (selectedPercentage / 100) * 180 - 90;

  return (
    <div className="gauge-container">
      <svg viewBox="0 0 100 50" className="gauge-svg">
        {/* Gauge background */}
        {/* <path
          d="M10,50 A40,40 0 0,1 90,50"
          fill="none"
          stroke="lightgray"
          strokeWidth="5"
        /> */}
        
        {/* Color segments */}
        <path d="M10,50 A40,40 0 0,1 30,10" stroke="red" strokeWidth="5" fill="none"/>
        <path d="M30,10 A40,40 0 0,1 50,5" stroke="orange" strokeWidth="5" fill="none"/>
        <path d="M50,5 A40,40 0 0,1 70,10" stroke="yellowgreen" strokeWidth="5" fill="none"/>
        <path d="M70,10 A40,40 0 0,1 90,50" stroke="green" strokeWidth="5" fill="none"/>
{/*Breaking It Down - M30,10 (Move To)
M means "move to", setting the starting point of the path.
30,10 is the (x, y) coordinate where the path starts.

A rx,ry x-axis-rotation large-arc-flag sweep-flag x,y */}
        {/* Needle */}
        <motion.line
  x1="50"
  y1="50"
  x2="50"
  y2="15"
  stroke="black"
  strokeWidth="2"
  initial={{ rotate: -90, originX: "50%", originY: "100%" }} // Correct transform origin
  animate={{ rotate: rotation }}
  transition={{ duration: 2, ease: "easeInOut" }}
 
/>

      </svg>
      <div className="Base">

      </div>
      <h3 className="Risk">Risk</h3>
      <div className="Bottom">
      <p>Highest</p>
      <p>Lowest</p>
      </div>
    </div>
  );
};

export default GaugeMeter;
